<template>
  <div class="vld-parent" ref="materials_container">
    <div v-if="empty" class="row">
      <div class="col-12 mb-3 text-center">
        <badge type="info" class="bg-white">
          Não existem materiais cadastrados no curso até o momento
        </badge>
      </div>
    </div>
    <div class="text-center mb-4">
      <base-button
        :custom="true"
        size="sm"
        type="primary"
        class="mb-3"
        v-tooltip="'Clique para cadastrar um novo material'"
        @click="
          $router.push(
            '/admin/trilha/cursos/' + $route.params.id + '/materiais/novo'
          )
        "
        ><i class="fas fa-plus mr-1"></i> Cadastrar novo material</base-button
      >
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="float-right">
          <base-button
            type="btn btn-white"
            class="mb-3 text-default"
            v-tooltip.bottom="'Gerenciar seções'"
            @click="
              $router.push(
                `/admin/trilha/cursos/${$route.params.id}/materiais/secoes`
              )
            "
            ><i class="fas fa-layer-group fa-lg mr-2" /> Seções</base-button
          >
          <span
            v-tooltip.bottom="
              'Ordenar/alterar ordem de exibição dos materiais do curso.'
            "
          >
            <base-button
              type="btn btn-white"
              class="mb-3 text-default"
              @click="
                $router.push(
                  `/admin/trilha/cursos/${$route.params.id}/materiais/ordenar`
                )
              "
              :disabled="totalMaterials <= 1"
              ><i class="fas fa-arrows-alt-v fa-lg mr-2" /> Ordenar</base-button
            ></span
          >
        </div>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div
            v-if="materials.withoutSection.length"
            :class="{
              'col-xl-6 mb-4': materials.sections.length,
              'col-xl-12 mb-4': !materials.sections.length,
            }"
          >
            <div class="card shadow table-container">
              <div class="card-header border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">
                      Lista de materiais
                      <span class="text-warning">sem seção</span>
                      <span
                        class="float-right"
                        v-if="materials.withoutSection.length"
                      >
                        <span class="font-weight-200 mx-2 small"
                          >{{ materials.withoutSection.length }}
                          {{
                            materials.withoutSection.length === 1
                              ? "material"
                              : "materiais"
                          }}</span
                        >
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <base-table
                  class="table align-items-center table-flush"
                  thead-classes="thead-light"
                  tbody-classes="list"
                  :data="materials.withoutSection"
                  type="hover"
                >
                  <template slot="columns">
                    <th>#</th>
                    <th>Status</th>
                    <th>Conteúdo</th>
                    <th>Título</th>
                    <th>Ações</th>
                  </template>
                  <template slot-scope="{ row, index }">
                    <td class="py-4">{{ index + 1 }}</td>
                    <td>
                      <div>
                        <badge
                          v-if="row.is_active"
                          type="success"
                          v-tooltip.bottom="
                            'O material está disponível para as startups que possuem acesso ao curso.'
                          "
                        >
                          Visível
                        </badge>
                        <badge
                          v-else
                          type="warning"
                          v-tooltip.bottom="
                            'O material está oculto para as startups.'
                          "
                        >
                          Oculto
                        </badge>
                      </div>
                    </td>
                    <td>{{ contentTypes[row.content].name }}</td>
                    <td>
                      <span :title="row.title">{{
                        truncate(row.title, 30)
                      }}</span>
                    </td>
                    <td>
                      <base-button
                        type="white"
                        size="sm"
                        @click="handleOpenModalView(row)"
                        class="text-primary"
                        v-tooltip.bottom="'Visualizar material'"
                      >
                        <i class="fas fa-eye"></i>
                      </base-button>
                      <base-button
                        type="white"
                        size="sm"
                        @click="handleOpenModalRemove(row)"
                        class="text-danger"
                        v-tooltip.bottom="'Excluir material'"
                      >
                        <i class="fas fa-trash text-danger"></i>
                      </base-button>
                      <router-link
                        :to="
                          '/admin/trilha/cursos/' +
                          $route.params.id +
                          '/materiais/' +
                          row.id +
                          '/editar'
                        "
                        v-tooltip.bottom="'Editar material'"
                        class="btn btn-white py-1 px-2"
                      >
                        <i class="fas fa-edit text-info"></i>
                      </router-link>
                    </td>
                  </template>
                </base-table>
                <p
                  v-if="!materials.withoutSection.length"
                  class="text-center text-warning mt-3"
                >
                  Não há materiais cadastrados sem seção vinculada.
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-xl-6 mb-4"
            v-for="(section, index) in materials.sections"
            :key="index"
          >
            <div class="card shadow table-container vld-parent">
              <div class="card-header border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">
                      <span class="text-success">{{ index + 1 }}. </span>
                      <span class="text-default">{{ section.title }}</span>
                      <span class="float-right" v-if="section.material.length">
                        <span class="font-weight-200 mx-2 small"
                          >{{ section.material.length }}
                          {{
                            section.material.length === 1
                              ? "material"
                              : "materiais"
                          }}</span
                        >
                      </span>
                    </h3>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <base-table
                  class="table align-items-center table-flush"
                  thead-classes="thead-light"
                  tbody-classes="list"
                  :data="section.material"
                  type="hover"
                >
                  <template slot="columns">
                    <th>#</th>
                    <th>Status</th>
                    <th>Conteúdo</th>
                    <th>Título</th>
                    <th>Ações</th>
                  </template>
                  <template slot-scope="{ row, index }">
                    <td class="py-4">{{ index + 1 }}</td>
                    <td>
                      <div>
                        <badge
                          v-if="!section.is_visible"
                          type="danger"
                          v-tooltip="
                            'A seção a qual o material pertence está oculta.'
                          "
                        >
                          Seção oculta
                        </badge>
                        <badge
                          v-else-if="row.is_active"
                          type="success"
                          v-tooltip="
                            'O material está disponível para as startups que possuem acesso ao curso.'
                          "
                        >
                          Visível
                        </badge>
                        <badge
                          v-else
                          type="warning"
                          v-tooltip="'O material está oculto para as startups.'"
                        >
                          Oculto
                        </badge>
                      </div>
                    </td>
                    <td>{{ contentTypes[row.content].name }}</td>
                    <td :title="row.title">
                      {{ truncate(row.title, 30) }}
                    </td>
                    <td>
                      <base-button
                        type="white"
                        size="sm"
                        @click="handleOpenModalView(row)"
                        class="text-primary"
                        v-tooltip.bottom="'Visualizar material'"
                      >
                        <i class="fas fa-eye"></i>
                      </base-button>
                      <base-button
                        type="white"
                        size="sm"
                        @click="handleOpenModalRemove(row)"
                        class="text-danger"
                        v-tooltip.bottom="'Excluir material'"
                      >
                        <i class="fas fa-trash text-danger"></i>
                      </base-button>
                      <router-link
                        :to="
                          '/admin/trilha/cursos/' +
                          $route.params.id +
                          '/materiais/' +
                          row.id +
                          '/editar'
                        "
                        v-tooltip.bottom="'Editar material'"
                        class="btn btn-white py-1 px-2"
                      >
                        <i class="fas fa-edit text-info"></i>
                      </router-link>
                    </td>
                  </template>
                </base-table>
                <p
                  v-if="!section.material.length"
                  class="text-center text-warning mt-3"
                >
                  Não há materiais cadastrados nesta seção até o momento.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="totalMaterials">
      <div class="col-12 text-muted text-right">
        <b>{{ totalMaterials }}</b> materiais vinculados ao curso ao total
      </div>
    </div>
    <modal
      :show.sync="modalView.show"
      modal-classes="modal-dialog-centered modal-lg"
      body-classes="pb-0"
      header-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Detalhes do material
      </h6>
      <div class="text-center">
        <i
          :class="['fas fa-3x', contentTypes[modalView.material.content].icon]"
          v-if="modalView.material"
        />
        <h3 class="mt-3">
          {{ modalView.material.title }}
        </h3>
        <p class="description mt-1 mb-0">
          {{ modalView.material.description }}
        </p>
        <p v-if="!modalView.material.is_active" class="mt-2">
          <badge type="warning" v-tooltip="'O material está oculto'"
            >Oculto</badge
          >
        </p>
        <div class="mt-4" v-if="modalView.material.content === 'file'">
          <base-button
            type="primary"
            @click="openLink(modalView.material.file_url)"
            >Visualizar arquivo
          </base-button>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'link'">
          <p class="mb-0 text-break" v-if="modalView.material.link">
            {{ modalView.material.link }}
          </p>
          <base-button
            type="primary mt-2"
            @click="openLink(modalView.material.link)"
          >
            Abrir link externo do material
          </base-button>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'text'">
          <div class="ml-container-read-only">
            <quill-editor
              v-if="modalView.material.text"
              v-model="modalView.material.text"
              :options="editorReadOnly"
              disabled="disabled"
              class="border rounded"
            ></quill-editor>
          </div>
        </div>
        <div
          class="mt-2"
          v-else-if="modalView.material.content === 'evaluation'"
        >
          <base-button
            class="mb-2"
            size="sm"
            @click="handleOpenAnswers(modalView.material)"
            type="primary"
            v-tooltip.bottom="'Ver respostas das startups'"
          >
            Ver respostas <i class="fas fa-user-edit ml-2"></i>
          </base-button>
          <div
            v-for="(question, index) in modalView.material.evaluation"
            :key="index"
            class="text-left"
          >
            <h4>Questão {{ index + 1 }} - {{ question.title }}</h4>
            <p class="description ml-2" v-if="question.description">
              <span class="font-weight-bold">Descrição: </span
              >{{ question.description || "-" }}
            </p>
            <p class="description ml-2">
              <span class="font-weight-bold">Tipo de questão: </span>
              {{ question.type_name }}
            </p>
            <div v-if="question.type !== 'text'" class="ml-2">
              <p class="description mb-0">
                <span class="font-weight-bold">Alternativas: </span>
              </p>
              <ul class="ml-3 description list-unstyled">
                <li
                  v-for="(option, index) in question.options"
                  :key="'op_' + index"
                >
                  <i
                    class="fas fa-angle-right mr-1"
                    v-if="question.right_answer === ''"
                  />
                  <i
                    class="fas fa-check text-success mr-1"
                    v-tooltip="'Alternativa correta'"
                    v-else-if="question.right_answer.includes(String(index))"
                  />
                  <i
                    class="fas fa-times text-danger mr-1"
                    v-tooltip="'Alternativa incorreta'"
                    v-else
                  />
                  {{ option.title }}
                </li>
              </ul>
            </div>
            <hr class="mt-3 mb-4" />
          </div>
        </div>
        <div class="mt-4" v-else-if="modalView.material.content === 'video'">
          <iframe
            width="100%"
            height="350"
            :src="`https://www.youtube.com/embed/${getYoutubeVideoId(
              modalView.material.video
            )}`"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; clipboard-write"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalView.show = false"
        >
          Voltar
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-2"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_remove">
        <div class="text-center">
          <i class="fas fa-trash fa-3x"></i>
          <h4 class="heading mt-4">Confirmar exclusão</h4>
          <p class="mt-3">
            Você confirma a remoção do material
            <span class="font-weight-bold">{{
              modalRemove.material.title
            }}</span
            >?
          </p>
        </div>
        <base-alert
          type="danger"
          class="text-center mb-2"
          v-if="modalRemove.error"
          >Ocorreu um erro ao remover o material. Por favor, tente
          novamente.</base-alert
        >
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button type="white text-danger" @click="handleRemoveMaterial">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { getIdFromUrl } from "vue-youtube";

import api from "@/services/api";

export default {
  name: "materiais_list",
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        section: {
          title: "",
          is_visible: true,
        },
      },
      materials: {
        sections: [],
        withoutSection: [],
      },
      course: "",
      totalMaterials: 0,
      empty: true,
      contentTypes: {
        video: { name: "Vídeo do YouTube", icon: "fa-play" },
        file: { name: "Arquivo", icon: "fa-file-alt" },
        link: { name: "Link externo", icon: "fa-external-link-alt" },
        text: { name: "Texto", icon: "fa-paragraph" },
        evaluation: { name: "Avaliação", icon: "fa-tasks" },
      },
      modalView: {
        show: false,
        material: "",
      },
      modalRemove: {
        show: false,
        material: "",
        error: "",
      },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      questionTypes: [
        {
          type: "radiobox",
          name: "Múltipla escolha",
        },
        { type: "checkbox", name: "Caixas de seleção" },
        { type: "text", name: "Texto" },
      ],
    };
  },
  async mounted() {
    await this.loadMaterials();
    this.getTotalMaterials();
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
    async loadMaterials() {
      const loader = this.$loading.show({
        container: this.$refs.materials_container,
        width: 110,
        height: 110,
        opacity: 0,
      });
      try {
        const { data } = await api.get(
          `/admin/courses/${this.$route.params.id}/materials`
        );
        this.$emit("courseTitle", data.course.title);
        this.course = data.course;
        if (data.hasOwnProperty("with_section"))
          if (data.with_section.length)
            this.materials.sections = data.with_section;
        if (data.hasOwnProperty("without_section"))
          this.materials.withoutSection = data.without_section;
        this.getTotalMaterials();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar os materiais do curso"
        );
      } finally {
        loader.hide();
      }
    },
    async handleOpenModalView(material) {
      if (material.content === "evaluation") {
        this.formatQuestion(material);
      }
      this.modalView.material = material;
      this.modalView.show = true;
    },
    async handleRemoveMaterial() {
      const loader = this.$loading.show({
        container: this.$refs.modal_remove,
        width: 90,
        height: 90,
        opacity: 0,
      });
      this.modalRemove.error = "";
      try {
        await api.delete(
          `/admin/courses/${this.$route.params.id}/materials/${this.modalRemove.material.id}`
        );
        this.$toasted.show("Material removido do curso com sucesso!");
        this.modalRemove.show = false;
        await this.loadMaterials();
        this.getTotalMaterials();
      } catch (e) {
        this.modalRemove.error = true;
        this.$toasted.error("Ocorreu um erro ao remover o material.");
      } finally {
        loader.hide();
      }
    },
    handleOpenModalRemove(material) {
      this.modalRemove.error = "";
      this.modalRemove.material = material;
      this.modalRemove.show = true;
    },
    truncate(text, stop = 30, clamp = "...") {
      if (!text) return "-";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    formatQuestion(material) {
      for (const question of material.evaluation) {
        if (question.parsed) continue;
        const contentIndex = this.questionTypes.findIndex(
          (item) => item.type === question.type
        );
        Object.assign(question, {
          type: this.questionTypes[contentIndex].type,
          type_name: this.questionTypes[contentIndex].name,
          parsed: true,
        });
        if (["radiobox", "checkbox"].includes(question.type)) {
          question.options = JSON.parse(question.options);
          if (question.right_answer !== "")
            question.right_answer = question.right_answer.split(",");
        }
      }
    },
    getTotalMaterials() {
      let totalMaterials = 0;
      totalMaterials +=
        this.materials.withoutSection.length +
        (this.materials.sections.length
          ? this.materials.sections.reduce(
              (count, section) => (count += section.material.length),
              0
            )
          : 0);
      this.totalMaterials = totalMaterials;
      if (this.totalMaterials) this.empty = false;
    },
    getYoutubeVideoId(url) {
      return getIdFromUrl(url);
    },
    handleOpenAnswers(material) {
      if (material.content === "evaluation") {
        this.$router.push(
          `/admin/trilha/cursos/${material.course_id}/avaliacoes/${material.id}/respostas`
        );
      }
    },
  },
};
</script>
<style scoped>
.cursor {
  cursor: pointer;
}

.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
</style>

<style>
.ml-container-read-only .quill-editor .ql-container,
.ml-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 10rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
